import React from "react";
import { useDispatch } from "react-redux";

import { keepAlive } from "src/features/auth/actions";
import { AppDispatch } from "src/store";

export function useKeepAlive(): () => Promise<void> {
	const dispatch: AppDispatch = useDispatch();
	return React.useCallback(() => {
		return dispatch(keepAlive());
	}, [dispatch]);
}
